import createVueComponent from '../createVueComponent';

const Tv2 = createVueComponent('Tv2Icon', [
  ['path', { d: 'M7 21h10' }],
  ['rect', { x: '2', y: '3', width: '20', height: '14', rx: '2' }],
]);

export default Tv2;
